import PlatformEvent from "../PlatformEvent";


export default new PlatformEvent("INFO", "CheckFail", "CheckFail", true)